// extracted by mini-css-extract-plugin
export default {"root":"AutoplayCarousel_root-pz5","track":"AutoplayCarousel_track-oHD","slide":"AutoplayCarousel_slide-ZHH"};